import React from "react";
import ReactDOM from "react-dom";
import {BrowserRouter, Route, Switch} from "react-router-dom";
import RTLLayout from "layouts/RTL/RTL.js";

import "assets/scss/black-dashboard-react.scss";
import "assets/demo/demo.css";
import "assets/css/nucleo-icons.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

import ThemeContextWrapper from "./components/ThemeWrapper/ThemeWrapper";
import BackgroundColorWrapper from "./components/BackgroundColorWrapper/BackgroundColorWrapper";
import {Provider} from "react-redux";
import store from "./utils/store/store";
import { createBrowserHistory } from "history";

const history = createBrowserHistory();

ReactDOM.render(
    <ThemeContextWrapper>
        <BackgroundColorWrapper>
            <BrowserRouter>
                <Provider store={store}>
                    <Switch>
                        <Route path="/" history={history} render={(props) => <RTLLayout {...props} />}/>
                    </Switch>
                </Provider>
            </BrowserRouter>
        </BackgroundColorWrapper>
    </ThemeContextWrapper>,
    document.getElementById("root")
);
